var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.498.109a.667.667 0 0 1 .193.923L4.158 7.965a.667.667 0 0 1-1.006.128L.218 5.427a.667.667 0 0 1 .897-.987L3.47 6.58 7.575.303a.667.667 0 0 1 .923-.193",
    clipRule: "evenodd"
  })));
};
export default SvgChecked;